// Which tracker API a page talks to, from the page's own host name.
//
//   tracker.geniusfeeds.live         -> https://trackerapi.geniusfeeds.live      (live)
//   tracker-<x>.geniusfeeds.live     -> https://trackerapi-<x>.geniusfeeds.live  (e.g. the tracker-v2 test name)
//   localhost / 127.0.0.1 / ::1      -> http://localhost:9000                    (dev)
//   anything else                    -> the live API
//
// Why: before 2026-11-03 every non-local page used the live API. A build served on the test name then talked to
// the OLD backend through the live DNS name, so a smoke check of a new box never reached the new backend.
// REACT_APP_TRACKER_API, set at build time, still overrides all of this.

export const LIVE_TRACKER_API = "https://trackerapi.geniusfeeds.live";
export const DEV_TRACKER_API = "http://localhost:9000";

const LOCAL_HOSTS = ["localhost", "127.0.0.1", "::1"];
const TRACKER_HOST = /^tracker(-[a-z0-9]+(?:-[a-z0-9]+)*)?\.geniusfeeds\.live$/;

export const trackerApiForHost = (hostname?: string): string => {
  const host = (hostname || "").toLowerCase();
  if (!host || LOCAL_HOSTS.includes(host)) return DEV_TRACKER_API;
  const m = TRACKER_HOST.exec(host);
  if (!m) return LIVE_TRACKER_API;
  return `https://trackerapi${m[1] || ""}.geniusfeeds.live`;
};
